// Extrai a mensagem de erro da resposta da API, com fallback pra uma mensagem
// genérica. Cobre três formatos: JSON do BFF (detail/message do FastAPI, ex.: 400
// "Empresa sem certificado configurado"), detail estruturado ({ codigo, mensagem },
// ex.: rotas de lote de rubricas) e corpo de erro em string pura (alguns endpoints
// do parser/serviço Java, ex.: "Já existe um arquivo igual no sistema!").
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mensagemErro = (err: any, fallback: string): string => {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  const detail = data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (typeof detail?.mensagem === "string" && detail.mensagem) return detail.mensagem;
  return typeof data?.message === "string" && data.message ? data.message : fallback;
};
